export const CATALOG_SECTIONS = {
  VERTICALS: {
    ID: '387',
    SUB_SECTIONS: {
      COMMUNICATIONS: '388',
      SECURITY: '389',
      HEALTH: '390',
      FINANCES: '391',
      GAMING: '544',
    },
  },
};

export const PROFILES = {
  R2R_V2: '306',
}

export const R2R_V2_306_DISCOUNTS_BY_CFI = {
  1: 150,
  2: 100,
  3: 50,
}

export const INCLUDED_R2R_DISCOUNTS_BY_CFI = {
  1: 300,
  2: 250,
  3: 150,
}

export const ARRAY_SUBSECCION = [
  CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS,
  CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.SECURITY,
  CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.HEALTH,
  CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.FINANCES,
  CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.GAMING,
];

/* FUSION CATEGORY */
export const FUSION_CATEGORY = {
  AV: 1, /* Alto valor */
  MV: 2, /* Medio valor */
  BV: 3 /* Bajo valor */
};

/* FUSION CATEGORY NAMES*/
export const FUSION_CATEGORY_NAMES = {
  AV: 'av', /* Alto valor */
  MV:'mv', /* Medio valor */
  BV:'bv' /* Bajo valor */
};

/* PRODUCT TYPES */
export const FUSION = 0; /* Internet fijo televisión y movil */
export const TRIO = 1; /* Internet, fijo y televisión */
export const DUO = 2; /* Internet y fijo */
export const ONLY_MOBILE = 3;
export const ONLY_PHONE = 4;
export const MOBILE_PREPAID = 5;
export const OTHERS = 9;
export const EQUIPAMIENTO = 9;
export const HEALTH = 9;

/* USER TYPES */
export const USUARIO_NO_LOGADO = 0;
export const USUARIO_LOGADO = 1;
export const USUARIO_LIBRE_SIN_LINEA_MOVIL = 2;
export const USUARIO_LIBRE_CON_LINEA_MOVIL = 3;
export const USUARIO_PRIMER_R2R_INCLUIDO = 4;
export const USUARIO_R2R_ADICIONAL = 5;
export const USUARIO_SEGUNDO_R2R_INCLUIDO = 6;
export const USUARIO_R2R_ADICIONAL_CON_RENOVACION = 7;

